import React, { useState } from "react";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from '@mui/material/FormHelperText';
import "animate.css/animate.css";
import './styles/TagCheckBox.css';

const TagCheckBox = (props) => {
  const [checkBoxValue, setCheckBoxValue] = useState(props.value);
  const validationCase = props.validationCase || 'none';
  const isTagChecked = props.isTagChecked || false;
  const isAlwaysOn = props.isAlwaysOn || false;

  const isEmpty = !checkBoxValue || checkBoxValue === 0 || checkBoxValue === '0';
  const error =
    (validationCase === 'case_4' && props.required && isAlwaysOn && isEmpty) ||
    (validationCase === 'case_2' && props.required && isTagChecked && isEmpty);
  const helperText = error
    ? (validationCase === 'case_4' ? 'This field is required' : 'This field is required if active')
    : '';

  const handleChange = (event) => {
    props.onChange({
      name: props.param,
      value: !checkBoxValue,
    });
    setCheckBoxValue(!checkBoxValue);
  };

  return (
    <div className="tag-checkbox-container">
      <FormControlLabel
        control={<Checkbox checked={Boolean(checkBoxValue)} color={error ? 'error' : 'primary'} />}
        label={props.label}
        onChange={handleChange}
        className="checkbox-label"
        sx={error ? { color: 'error.main' } : undefined}
      />
      {helperText && <FormHelperText error>{helperText}</FormHelperText>}
    </div>
  );
};

export default TagCheckBox;
